<template>
  <div>
    <div><input v-model='days' @keyup.enter="enterClicked()"/></div>
    <div class="row">
      <div class="col-sm-12 graph-box">
        <EtatsDesPlans height=100 width=300 :data=data.changements></EtatsDesPlans>
      </div>
      <div class="col-sm-6 graph-box">
        <SommeDesStatuts :height=200 :width=300 :data=data.statut></SommeDesStatuts>
      </div>
      <div class="col-sm-6 graph-box">
        <SoumissionParStatut :height=200 :width=300 :data=data.soumission_par_statut></SoumissionParStatut>
      </div>

    </div>
  </div>
</template>

<script>
import EtatsDesPlans from '@/components/EtatsDesPlans.vue';
import SommeDesStatuts from '@/components/SommeDesStatuts.vue';
import SoumissionParStatut from '@/components/SoumissionParStatut.vue';
import axios from 'axios';

export default {
  data: function() {return {
    days: 45,
    data: {
      changements:[],
      statut:[],
      soumission_par_statut:{}
    }
  }},

  name: 'Plans',
  components: {
    EtatsDesPlans,
    SommeDesStatuts,
    SoumissionParStatut
  },
  methods: {
    enterClicked: function() {
      this.refresh()
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/statut_plan.php',
          { params: {days: this.days} })
        .then(response => (this.data = response.data))
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style>
</style>
